import { Typography } from "@mui/material";
import React, { useContext } from "react";
import { BiMenu } from "react-icons/bi";
import { useLocation } from "react-router-dom";
import APP_LIST from "../../config/constants/routes";
import { HeaderPortalContext } from "../../config/contexts/HeaderPortalContext";
import {
  StyledHeader,
  StyledHeaderLeft,
  StyledHeaderRight,
  StyledMenuIconWrapper,
} from "./styles";

const Header = ({ toggleSidebar }) => {
  const location = useLocation();
  const { portalContent } = useContext(HeaderPortalContext);

  const title =
    APP_LIST.find((app) => location.pathname.includes(app.path))?.title ??
    "Welcome to psyMing!";

  return (
    <StyledHeader>
      <StyledHeaderLeft>
        <StyledMenuIconWrapper onClick={toggleSidebar}>
          <BiMenu fontSize={30} />
        </StyledMenuIconWrapper>
        <Typography>{title}</Typography>
      </StyledHeaderLeft>
      <StyledHeaderRight id="header-cta-container">
        {portalContent}
      </StyledHeaderRight>
    </StyledHeader>
  );
};

export default Header;
